  
import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import apiClient from "./plugins/axios";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';  

const CURRENT_APP_VERSION = '1.0.0';
const storedVersion = localStorage?.getItem('app_version');

if (storedVersion && storedVersion !== CURRENT_APP_VERSION) {
  localStorage.setItem('app_version', CURRENT_APP_VERSION);
  window.location.reload(true);
} else if (!storedVersion) {
  localStorage.setItem('app_version', CURRENT_APP_VERSION);
}

const app = createApp(App);
app.config.globalProperties.$axios = apiClient;
app.config.globalProperties.$server = "https://ksvidyalay.com/back/";
app.config.globalProperties.$hostname = 'https://ksvidyalay.com/back/'
app.config.globalProperties.$asset_path = 'https://ksvidyalay.com/back/public/uploads/'
app.provide('$axios', apiClient); // Provide Axios globally
 
app.use(store);
app.use(VueSweetalert2);
app.use(router).mount('#app');